import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MainContainer, OutlinedButton, PaperBox, SmileGoodIcon } from '../.';
import { useEnvironment } from '../contexts';
import React from 'react';
export var CliLoginSuccess = function CliLoginSuccess() {
    var environment = useEnvironment().environment;
    var backHome = function backHome() {
        window.location.href = environment.dashboardUrl;
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsx(PaperBox, {
            footer: /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsx(OutlinedButton, {
                    label: "Back to Home page",
                    onClick: backHome
                })
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: "mt-8 w-full gap-4 flex flex-row items-center justify-between",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-row items-center",
                            children: [
                                /*#__PURE__*/ _jsx(SmileGoodIcon, {}),
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "ml-2 text-[var(--color-primary-success)] text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0",
                                    children: "Zephyr CLI Login Success!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-3",
                            children: "Zephyr CLI was successfully authenticated"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "font-normal text-sm text-[var(--color-secondary)]",
                            children: "Now you can close this tab and return to the CLI."
                        })
                    ]
                })
            })
        })
    });
};
